import script from "./sellerTag.vue?vue&type=script&setup=true&lang=js"
export * from "./sellerTag.vue?vue&type=script&setup=true&lang=js"

import "./sellerTag.vue?vue&type=style&index=0&id=bb8ef60e&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8ef60e"]])

export default __exports__